import { render, staticRenderFns } from "./AffidavitPersonalService.vue?vue&type=template&id=032778d7"
import script from "./AffidavitPersonalService.vue?vue&type=script&lang=ts"
export * from "./AffidavitPersonalService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports